import React, { useState } from 'react';
import FsLightbox from 'fslightbox-react';
import { FaPlay } from 'react-icons/fa';
import SectionTitle from '../sectionTitle/SectionTitle';
import { Link } from 'react-router-dom';

const HTBDBanner = () => {
    const [toggler, setToggler] = useState( false );
    const videoLink = ['https://www.youtube.com/watch?v=xZZ-wSo0jak&ab_channel=SeedingBrains-TQUK'];
    return (
        <>
            <div className="edu-service-area service-wrapper-3">
                <div className="about-us-two-service-wrapper edu-section-gapTop bg-image position-relative">
                    <div className="eduvibe-about-us-two-service">
                        <div className="container eduvibe-animated-shape">
                            <div className="row">
                                <div className="col-lg-12">
                                    {/* <SectionTitle
                                        classes = "text-center"
                                        slogan = "HTBD"
                                        title = "How To Do Business In Dubai"
                                    /> */}
                                <div className='section-title text-center'>
                                    <img src='/images/htbd/htbd.webp' /><br/>   
                                     {/* <span className="pre-title">HTBD</span> */}
                                <h1 className="title">How To Do Business In Dubai</h1>
                                <p className='my-5'>Department - Seeding Brains RSDs Mr. Chinmay Chitransh - Program manager</p>
                                <Link to="https://buy.stripe.com/00gg1zclJf1PeKA6oo" target='_blank'><button className='edu-btn mb-4'>Register</button></Link>
                                </div>
                                </div>
                            </div>

                            {/* <FeatureTwo /> */}

                            <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
                                <div className="shape-image shape-image-1">
                                    <img src="/images/shapes/shape-29.webp" alt="Shape Thumb" />
                                </div>
                                <div className="shape-image shape-image-2">
                                    <img src="/images/shapes/shape-02-06.webp" alt="Shape Thumb" />
                                </div>
                            </div>
                        </div>
                    </div>
                        
                    <div className="eduvibe-about-us-two-video">
                        <div className="container eduvibe-animated-shape">
                            <div className="row">
                                <div className="col-lg-10 offset-lg-1">
                                    <div className="video-gallery-wrapper edu-section-gapTop video-section-overlayto-another">
                                        <div className="video-gallery-1">
                                            <div className="thumbnail video-popup-wrapper">
                                                <img className="radius-small w-100" src={`${process.env.PUBLIC_URL}./images/htbd/htbd-video-banner.webp`} alt="Video PopUp Thumb" />
                                                <button className="video-play-btn with-animation position-to-top video-popup-activation btn-secondary-color size-80" onClick={ () => setToggler( ! toggler ) }>
                                                    <span><FaPlay className="play-icon" /></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
                                <div className="shape-image shape-image-1">
                                    <img src="/images/shapes/shape-07-01.webp" alt="Shape Thumb" />
                                </div>
                                <div className="shape-image shape-image-2">
                                    <img src="/images/shapes/shape-03-02.webp" alt="Shape Thumb" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FsLightbox 
                toggler={ toggler } 
                sources={ videoLink }
                maxYoutubeVideoDimensions={ { width: 900, height: 550 } }
            />
        </>
    )
}

export default HTBDBanner;